module.exports = __webpack_public_path__ + "img/Skirt-Front-B1-Da-Fb-Gb-Hc-Ia.c272f499.png";